<template>
	<div class="w-full">
		<GridLayout :sidebar-state="sidebarState">
			<template #right-header>
				<div class="w-full h-full flex items-center gap-3">
					<button
						class="btn btn-rounded"
						@click="Previous"
					>
						<i class="fas fa-chevron-left"></i>
					</button>
					<Steps
						:steps-map="stepsMap"
						:current-step="currentStep"
						@select-step="
							currentStep = $event
							autoNav = false
						"
					/>
				</div>
			</template>
			<template #right-content>
				<transition
					name="fade"
					mode="out-in"
				>
					<div v-if="step === 'pre'"></div>

					<MainContent v-if="step === 'schedules'">
						<Schedules
							ref="schedules"
							class="w-full flex-1 flex flex-col py-4"
							type="scheduling"
							:modality_id="scheduling.modality_id"
							:proceedings="scheduling.proceedings"
							:schedules="scheduling.schedules"
							@next="WalkStep"
						/>
					</MainContent>

					<AttendancePriority
						v-if="step === 'attendance_priority'"
						ref="attendance_priority"
						class="w-full flex-1 flex flex-col py-4"
						:classification="scheduling.classification"
						@next="WalkStep"
					/>

					<MainContent v-if="step === 'confirm'">
						<Confirm
							ref="confirm"
							class="w-full flex-1 flex flex-col py-4"
							type="rescheduling"
							:module_id="selected_module_id"
							:modality_id="scheduling.modality_id"
							:partnership="scheduling.partnership"
							:proceedings="proceedings"
							:time="scheduling.time"
							:patient="scheduling.patient"
							:classification="scheduling.classification"
							:print-statement="printStatement"
							:indicator="scheduling.indicator"
							@indicator="SetIndicator"
							@next="WalkStep"
						/>
					</MainContent>
				</transition>
			</template>
			<template #right-footer>
				<div class="w-full h-full flex justify-end items-center gap-3">
					<button
						class="btn btn-fixed-size btn-success"
						type="button"
						@click="Continue"
					>
						{{ step === 'confirm' ? 'REAGENDAR' : 'CONTINUAR' }}
					</button>
				</div>
			</template>
		</GridLayout>
	</div>
</template>

<script>
	import Schedules from '@/components/shared/scheduling/Schedules'
	import Confirm from '@/components/shared/scheduling/Confirm'
	import { useConfirmation, useError } from '@/composables'

	import _ from 'lodash'

	import Helpers from '../../helpers'
	const helpers = new Helpers()

	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	export default {
		name: 'ReschedulingWizard',
		components: {
			Schedules,
			Confirm,
		},
		props: {
			source: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				source_page: '',
				schedulings: [],
				iter: 0,
				scheduling: {
					module_id: null,
					modality_id: null,
					schedules: [],
					proceeding: null,
					partnership: null,
					billing: null,
					time: null,
					patient: null,
					place: null,
					classification: 1,
					obs: '',
					indicator: null,
					payment_info: null,
					origin: 2, // ORIGIN_SCHEDULING_PRE_APPOINTMENT
					instructions: '',
				},
				printStatement: false,
				sidebarState: false,
				currentStep: 0,
				stepsMap: [
					{
						key: 'pre',
					},
					{
						key: 'schedules',
						number: 1,
						label: 'AGENDA',
						isValid: false,
					},
					{
						key: 'confirm',
						number: 2,
						label: 'AGENDAR',
						isValid: false,
					},
				],
				finishButtonLabel: 'CONTINUAR',
				autoNav: true,
			}
		},
		computed: {
			...mapGetters('auth', [
				'requester_selected_id',
				'requester_selected_object',
			]),
			...mapGetters('system', ['modules']),
			selected_module_id() {
				const module = this.modules.find(
					m => m.name === this.scheduling.module
				)

				return module.id
			},
			proceedings() {
				return [{ ...this.scheduling.proceeding }]
			},
			step() {
				return this.stepsMap[this.currentStep].key
			},
		},
		watch: {
			step: {
				handler(val) {
					let hash = ''

					switch (val) {
						case 'schedules':
							hash = '#horarios'
							break
						case 'confirm':
							hash = '#confirmacao'
							break
					}

					window.location.hash = hash
				},
				immediate: true,
			},
			$route(to) {
				switch (to.hash) {
					case '#horarios':
						this.currentStep = 1
						break
					case '#confirmacao':
						this.currentStep = 2
						break
				}
			},
		},
		methods: {
			...mapActions('system', [
				'StartLoading',
				'FinishLoading',
				'GetModulesAndModalities',
			]),
			async LoadScheduling(scheduling_id) {
				await this.GetSchedulingData(scheduling_id)

				const override = this._schedulings_data?.find(
					d => d.id == scheduling_id
				)

				if (override) {
					if (override.billing)
						this.scheduling.billing = override.billing
					if (override.indicator)
						this.scheduling.indicator = override.indicator
					if (override.partnership)
						this.scheduling.partnership = override.partnership
				}

				await this.GetProceedingsDetails(
					this.scheduling.proceeding.id,
					this.scheduling.partnership.id
				)
			},
			async WalkStep(param = null) {
				switch (this.step) {
					case 'pre':
						await this.LoadScheduling(this.schedulings[this.iter])
						this.currentStep = 1
						break
					case 'schedules':
						this.scheduling.time = param
						Object.assign(this.scheduling, {
							classification: 1,
							obs: '',
							place: null,
							origin: this.GetAttendanceOrigin(),
						})
						this.stepsMap[this.currentStep].isValid = true
						this.currentStep = 2
						break
					case 'confirm':
						Object.assign(this.scheduling, {
							obs: param.obs,
							place: param.place,
							payment_info: param.payment_methods_info,
							instructions: param.instructions,
						})
						await this.ToReschedule()
						break
				}
			},
			Previous() {
				switch (this.step) {
					case 'schedules':
						window.history.go(-2)
						break
					case 'confirm':
						this.currentStep = 1
						break
				}
			},
			DynamicPrevious() {
				if (this.step == 'schedules') {
					window.history.go(-2)
				} else if (this.step == 'confirm') {
					this.currentStep = 1
				}
			},
			async GetProceedingsDetails(proceeding_id, partnership_id) {
				this.StartLoading()

				return await window.api
					.call('post', '/get-proceeding-details', {
						account_id: this.requester_selected_id,
						modality_id: this.scheduling.modality_id,
						proceeding_id,
						partnership_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.scheduling.schedules = _.orderBy(
								data.schedules,
								'nome'
							)
							this.scheduling.proceedings =
								data.partnership.proceedings
							this.scheduling.proceeding =
								data.partnership.proceedings[0]
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async GetSchedulingData(scheduling_id) {
				const vm = this

				vm.StartLoading()

				return window.api
					.call('post', '/get-scheduling-data', {
						account_id: vm.requester_selected_id,
						scheduling: scheduling_id,
					})
					.then(({ data }) => {
						if (data.response) {
							const scheduling = data.scheduling

							vm.scheduling = { ...scheduling }
							vm.scheduling.patient = scheduling.journey.patient
							vm.scheduling.partnership =
								scheduling.partnerships[0]
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			GetAttendanceOrigin() {
				const ORIGIN_SCHEDULING_PRE_APPOINTMENT = 2
				const ORIGIN_SCHEDULING_URGENT_APPOINTMENT = 3

				const SCHEDULING_CONTINOUS = 3

				let origin = ORIGIN_SCHEDULING_PRE_APPOINTMENT

				origin =
					this.scheduling.time.tipo === SCHEDULING_CONTINOUS
						? ORIGIN_SCHEDULING_URGENT_APPOINTMENT
						: ORIGIN_SCHEDULING_PRE_APPOINTMENT

				return origin
			},
			ToReschedule() {
				this.StartLoading()

				delete this.scheduling.schedules

				return window.api
					.call('post', '/to-reschedule', {
						scheduling_id: this.scheduling.id,
						account_id: this.requester_selected_id,
						...this.scheduling,
						proceedings: this.proceedings,
					})
					.then(({ data }) => {
						if (data.response) {
							this.printStatement = true

							Swal.fire({
								icon: 'question',
								title: 'DESEJA IMPRIMIR OS DADOS DO REAGENDAMENTO?',
								showConfirmButton: true,
								showCancelButton: true,
								confirmButtonText: 'SIM',
								cancelButtonText: 'NÃO',
								reverseButtons: true,
								customClass: {
									container: 'themed confirmation',
								},
							}).then(async res => {
								if (res.isConfirmed) {
									this.PrintTimeline(data.journey)

									this.printStatement = false
								}

								useConfirmation()

								this.currentStep = 0
								this.iter++

								await this.WalkStep()

								if (this.iter == this.schedulings.length) {
									if (this.source_page) {
										await this.$router
											.push({ name: this.source_page })
											.catch(e => {
												console.error(e)
												this.$router.push({
													name: 'Home',
												})
											})
									} else {
										await this.$router.push({
											name: 'Home',
										})
									}
								}
							})
						} else {
							useError(
								'HOUVE UM ERRO AO CONCLUIR, CONTATE O SUPORTE'
							)
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			CancelScheduling() {
				this.StartLoading()

				let arr = []

				arr.push({ id: this.schedulings[this.iter] })

				return window.api
					.call('post', '/cancel-schedulings', {
						schedulings: arr,
						organization_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.currentStep = 0
							this.WalkStep()

							return data
						} else {
							useError(
								'HOUVE UM ERRO AO EXCLUIR O AGENDAMENTO ANTERIOR, CONTATE O SUPORTE'
							)
						}
					})
					.finally(() => {
						this.dialog = false

						this.FinishLoading()
					})
			},
			PrintTimeline(journey_id) {
				const fn = event => {
					if (event.data.print) {
						window.removeEventListener('message', fn)

						win.close()
					}
				}

				const win = window.open(
					`/pesquisa/imprimir?journey_id=${journey_id}`,
					'_blank'
				)
				win.mainWindow = window
				window.addEventListener('message', fn)
			},
			SetIndicator(indicator) {
				this.scheduling.indicator = indicator
			},
			Continue() {
				this.$refs.confirm.Continue()
			},
		},
		async beforeMount() {
			this.source_page = this.$route.params.source
			await this.GetModulesAndModalities({
				with_instructions: true,
			})

			this.schedulings = JSON.parse(this.$route.query.schedulings)
			this._schedulings_data = this.$route.query.schedulings_data
				? JSON.parse(this.$route.query.schedulings_data)
				: null

			this.WalkStep()
		},
	}
</script>

<style lang="css" scoped></style>
